export const isWhenCalledTrigger = (step) => step?.type === 'trigger' && step?.appSlug === 'runWorkflow';
